import { SubTypes } from './capabilties/vm/constatnts';
import { Context, Params } from './types/global';
import * as types from '@/components/Database/database.types';
import * as cloudTypes from '@/components/Cloud/Dashboard/cloud.types';

enum ScopeTypes {
  /** @member {string} */
  SERVICE = 'Service',
  /** @member {string} */
  ENDPOINT = 'Endpoint',
  /** @member {string} */
  SERVICE_INSTANCE = 'ServiceInstance',
}

const createConfig = (context: Context, params: Params, vmSubType: String) => {
  let config = {} as any;
  if (vmSubType === SubTypes.WINDOWS) {
    if (params.children.present) {
      config =
        context.rootState.globalState.app.chartsTemplate.detailsWindows[
          params.layoutIndex
        ][params.index].childQueries[params.children.childIndex];
    } else {
      config =
        context.rootState.globalState.app.chartsTemplate.detailsWindows[
          params.layoutIndex
        ][params.index];
    }
    return config;
  } else {
    if (params.children.present) {
      config =
        context.rootState.globalState.app.chartsTemplate.details[
          params.layoutIndex
        ][params.index].childQueries[params.children.childIndex];
    } else {
      config =
        context.rootState.globalState.app.chartsTemplate.details[
          params.layoutIndex
        ][params.index];
    }
    return config;
  }
};
const createConfigDatabase = (context: Context, params: Params) => {
  let config = {} as any;
  if(context.rootState.databaseState.databaseCommonState.currentDatabaseType.key == types.DatabaseTypes.cb || context.rootState.databaseState.databaseCommonState.currentDatabaseType.key == types.DatabaseTypes.mg)
  {
  var template =
    context.rootState.globalState.app.chartsTemplate[
      context.rootState.databaseState.databaseCommonState.currentDatabaseType
        .key
    ][context.rootState.databaseState.detail.currentSubType.key].graphs
      .template[params.layoutIndex];
  } else {
    var template =
      context.rootState.globalState.app.chartsTemplate[
        context.rootState.databaseState.databaseCommonState.currentDatabaseType
          .key
      ][context.rootState.databaseState.detail.currentSubType.key].graphs
        .template;
  }
  config = template[params.index];
  return config;
};

const createConfigCloud = (context: Context, params: Params) => {
  let config = {} as any;
  const service = context.rootState.cloudState.services.cloudSvc;
  const currentPage = context.rootState.cloudState.detail.currentPage;
  const matchedSubType = cloudTypes.subTypesWithTabs.find(
    (item) => item.subType === service && item.page === currentPage
  );
  if (matchedSubType) {
    var template = context.rootState.globalState.app.chartsTemplate.AWS[service][
      context.rootState.cloudState.detail.currentPage
    ].navItems.find((item) => item.key === context.rootState.cloudState.detail.currentTab)?.template;
  } else {
    var template =
      context.rootState.globalState.app.chartsTemplate.AWS[service][
        context.rootState.cloudState.detail.currentPage
      ].graphs?.template;
    }
    config = template?.[params.index];
  return config;
};

const createConfigMobile = (context: Context, params: Params) => {
  let config = {} as any;
  if (params.children.present) {
    config =
      context.rootState.globalState.app.chartsTemplate.performance[
        params.layoutIndex
      ][params.index].childQueries[params.children.childIndex];
  } else {
    config =
      context.rootState.globalState.app.chartsTemplate.performance[
        params.layoutIndex
      ][params.index];
  }
  return config;
};

const createConfigWSM = (context: Context, params: Params) => {
  let config = {} as any;
  var template =
    context.rootState.globalState.app.chartsTemplate[
      context.rootState.wsmState.wsmCommonState.currentWSMType.key
    ][context.rootState.wsmState.detail.currentSubType.key].graphs.template;
  config = template[params.index];

  return config;
};

const createConfigSM = (context: Context, params: Params) => {
  let config = {} as any;
  if (params.dependency === 'Pulse') {
    config = context.rootState.syntheticState.applications.chartTemplate;
    return config;
  }
  config =
    context.rootState.globalState.app.chartsTemplate.application[
      params.layoutIndex
    ][params.index];
  return config;
};

// const createConfigSMAvailabilty = (context: Context, params: Params) => {
//   let config = {} as any;
//   config =
//     context.rootState.syntheticState.uptimeModal.chartsTemplate[
//       params.layoutIndex
//     ] [params.index];
//     return config;
// };

/**
 * @description split string by ',' and remove the space at the beginning and end of the substrings and returns array
 */
const parse = (metricName: String) => {
  return metricName
    .split(',')
    .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
};

/**
 * @constant
 * @example
 *  * # Contents of `variablesList`
 * ```Array
 * [
 *   {
 *  "duration": {
 *    "start": "2021-06-09",
 *     "end": "2021-07-09",
 *      "step": "DAY"
 *  },
 *   "condition": {
 *    "name": "service_apdex",
 *     "entity": {
 *          "scope": "Service",
 *        "serviceName": "eyduYW1lJzonZ28tYXBpLXVzZXInLCd0ZWFtSUQnOidiNzA2ODFhOC00ZWI3LTQ2OGYtOGJlNi04NWRlZDQ1NzEyM2EnLCd0eXBlJzonQSd9.1",
 *       "normal": true
 *     }
 *  }
 * }
 * ]
 * ```
 * @description creates the variable for grqphQL API
 *
 */
const createVariableList = (
  metricNames: string[],
  params: Params,
  config: any,
  names: string[],
  labels: any,
  normal: boolean,
  currentVmId: string,
  currentVmInstance?: string,
  isCompared?: Boolean,
) => {
  const variableList =
    Array.isArray(metricNames) &&
    metricNames.map((name: string) => {
      let variables = {} as any;
      /**
       * @description This is for getting global data
       */
      if (config.entityType === 'All') {
        variables = names.includes(config.queryMetricType)
          ? {
              duration: params.duration,
              condition: {
                name,
                parentService: null,
                normal: true,
                scope: config.entityType,
                topN: 10,
                order: config.sortOrder || 'DES',
              },
            }
          : {
              duration: params.duration,
              condition: {
                name,
                entity: {
                  scope: config.entityType,
                  normal: true,
                },
              },
              labels,
            };
      } else {
        /**
         * @description This macthes the query types and constructs the graphQL API
         * @example
         *  * # Contents of `variablesList`
         * ```
         *  "name": "service_apdex",
         *  * ```
         */
        if (names.includes(config.queryMetricType)) {
          const parentService = normal ? currentVmId : '';
          if (config.parentService && !parentService) {
            return;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              parentService: config.parentService ? currentVmId : null,
              normal,
              scope: normal
                ? config.entityType
                : config.parentService
                  ? 'Service'
                  : config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES',
            },
          };
        } else {
          const serviceName = normal ? currentVmId : null;
          if (!serviceName) {
            return null;
          }

          /**
           * @description variable constructor
           */
          variables = {
            duration: params.duration,
            condition: {
              name,
              entity: {
                scope: normal ? config.entityType : ScopeTypes.SERVICE,
                serviceName,
                normal,
                serviceInstanceName: currentVmInstance ? currentVmInstance : '',
              },
            },
            labels,
          };
          if(isCompared){
            const serviceName = normal ? currentVmId : null;
          if (!serviceName) {
            return null;
          }
            variables = {
              durationCurrent: params.duration,
              durationCompare: params.compareDuration,
              condition: {
                name,
                entity: {
                  scope: normal ? config.entityType : ScopeTypes.SERVICE,
                  serviceName,
                  normal,
                  serviceInstanceName: currentVmInstance ? currentVmInstance : '',
                },
              },
              labels,
            };
          }
        }
      }

      return variables;
    });
  return variableList;
};

export default {
  createConfig,
  parse,
  createVariableList,
  createConfigDatabase,
  createConfigMobile,
  createConfigWSM,
  createConfigSM,
  createConfigCloud,
};
